import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";

import type { GeneralRegionalClassificationResponse } from "./generalRegionalClassification.types";

const GENERAL_REGIONAL_CLASSIFICATION_QUERY_KEY = "general-regional-classification";

export const getGeneralStructureRegionalClassification = async (
  structureId: string,
): Promise<GeneralRegionalClassificationResponse> =>
  axiosGetData<GeneralRegionalClassificationResponse>(
    `v1/general/structures/${structureId}/regional-classification`,
  );

export const generalStructureRegionalClassificationQueryOptions = (structureId: string) => ({
  queryKey: [GENERAL_REGIONAL_CLASSIFICATION_QUERY_KEY, structureId],
  queryFn: () => getGeneralStructureRegionalClassification(structureId),
});

export const useGeneralStructureRegionalClassificationQuery = (
  structureId: string | undefined,
  options?: Partial<UseQueryOptions<GeneralRegionalClassificationResponse, AxiosError>>,
) =>
  useQuery<GeneralRegionalClassificationResponse, AxiosError>({
    ...generalStructureRegionalClassificationQueryOptions(structureId ?? ""),
    enabled: Boolean(structureId),
    ...options,
  });
